import React, { Component } from 'react';
import withGettext from 'react-gettext';
import './App.css';
import {configure} from './config';
import LoggedInView from './LoggedInView';
import Welcome from './authentication/Welcome';
import { getModel } from './data/Model.js';
import en from './data/locale/en.json'
import UploadingPhotosInfo from "./UploadingPhotosInfo";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import { getSelectedClients } from './data/interactions';
import { BrowserRouter as Router } from 'react-router-dom'
import { POST_LOGIN_REDIRECT_KEY } from './postLoginRedirect'

const theme = createMuiTheme({
  typography: {
    fontFamily: 'Lato',
  },
})

class App extends Component {
  componentDidUpdate = () =>{
    if(getModel().me.status.handle === "loaded"){
      this.checkAndRedirect(["SPX", "TTN"]);
    };
  }
  checkAndRedirect = (names) => {
    if(getModel().me.data.permission_level === "admin") return;
    const clientNames = getSelectedClients().map(client => client.short_name);
    if(!clientNames.length) return;
    for(const name in clientNames) {
      if(names.includes(name)) {
        window.location.replace("https://client.copyrightagent.com");
      }
    }
  }
  // Backoffice is linked to directly from other systems, so remember where the
  // user was heading and send them there once they have logged in.
  redirectToLogin = () => {
    try {
      sessionStorage.setItem(
        POST_LOGIN_REDIRECT_KEY,
        window.location.pathname + window.location.search
      );
    } catch (error) {
      console.error(error);
    }
    window.location.replace("/");
  }
  render() {
    const Model = getModel();

    return (
      <MuiThemeProvider theme={theme}>
        {!Model.auth_token && window.location.pathname !== '/'
        && window.location.pathname !== '/forgot-password'
        && window.location.pathname !== '/change-password'
        && (
          this.redirectToLogin()
        )}
        {Model.auth_token && <Router><LoggedInView /></Router>}
        <Welcome />
        {getModel().uploadPhotoQueue && getModel().uploadPhotoQueue.length > 0 && (
          <UploadingPhotosInfo/>
        )}
      </MuiThemeProvider>
    );
  }
}

export const createApp = async () => {
    const config = window.CA_APP_CONFIG || {};
    configure(config);
    return withGettext(en, 'n != 1')(App)
};
